<template>
  <v-card
    :class="[compactMode ? 'ma-0 pa-2' : 'mt-1 mb-0 mx-0 pa-2']"
    :style="{ height: cardHeight + 'px', overflowY: 'auto' }"
  >
    <v-layout column>
      <ShippingPhases
        v-if="
          compactMode ||
            (!compactMode && !isPhasesDone && !isReleaseOrderActive) ||
            (!compactMode && !isPhases && !isReleaseOrderActive) ||
            (!compactMode && !isReleaseOrderActive && isPhaseActive)
        "
        :can-edit="canEdit"
        :user="user"
      />
      <v-divider
        v-if="compactMode"
        horizontal
        class="my-4"
      />
      <ShippingReleaseOrders
        v-if="
          compactMode ||
            (!compactMode && isPhasesDone && !isPhaseActive) ||
            (!compactMode && isReleaseOrderActive && !isPhaseActive)
        "
        :can-edit="canEdit"
        :shipping-id="id"
      />
    </v-layout>
  </v-card>
</template>
<script>
import ShippingPhases from "./ShippingPhases.vue";
import ShippingReleaseOrders from "../release-orders/ShippingReleaseOrders.vue";

export default {
  components: {
    ShippingPhases,
    ShippingReleaseOrders,
  },
  props: ["id", "canEdit", "user"],
  data() {
    return {
      isPhases: false,
      phasesLoading: false,
    };
  },
  computed: {
    cardHeight() {
      return this.compactMode ? window.innerHeight - 45 : 197;
    },
    phases() {
      return this.$store.getters["shipping/phases"];
    },

    client() {
      return this.$store.getters["shipping/client"];
    },
    readonly() {
      return this.$store.getters["shipping/splitted"];
    },
    isPhaseActive: {
      get() {
        return this.$store.getters["shipping/isPhaseActive"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsPhaseActive", value);
      },
    },
    isPhasesDone: {
      get() {
        return this.$store.getters["shipping/isPhasesDone"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsPhasesDone", value);
      },
    },
    lastPhase: {
      get() {
        return this.$store.getters["shipping/lastPhase"];
      },
      set(item) {
        return this.$store.commit("shipping/setLastPhase", item);
      },
    },
    isReleaseOrderActive: {
      get() {
        return this.$store.getters["shipping/isReleaseOrderActive"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsReleaseOrderActive", value);
      },
    },
    compactMode: {
      get() {
        return this.$store.getters["shipping/compactMode"];
      },
      set(value) {
        return this.$store.commit("shipping/setCompactMode", value);
      },
    },
  },
  watch: {
    phases: {
      handler() {
        if (this.phases.length != 0) {
          const lastPhase = this.phases.find(
            (i, index) => index === this.phases.length - 1,
          );
          this.$store.commit("shipping/setLastPhase", lastPhase);
          const isPhasesDone =
            this.phases.filter(i => i.state.id !== 3).length > 0 ? false : true;
          this.isPhases = this.phases.length === 0 ? false : true;
          this.$store.commit("shipping/setIsPhasesDone", isPhasesDone);

          const isPhaseActive = this.isPhasesDone ? false : true;
          this.$store.commit("shipping/setIsPhaseActive", isPhaseActive);
          const isReleaseOrderActive = this.isPhasesDone ? true : false;
          this.$store.commit(
            "shipping/setIsReleaseOrderActive",
            isReleaseOrderActive,
          );
        } else {
          this.$store.commit("shipping/setIsPhaseActive", true);
          this.$store.commit("shipping/setIsReleaseOrderActive", false);
        }
        this.$store.dispatch("shipping/updateDates", this.id);
      },
      immediate: true,
    },
  },
  async created() {
    if (!this.user.hasEmployee) {
      return;
    }
    await this.$store.dispatch("shipping/getPhases", this.id);
    await this.$store.dispatch("shipping/getReleaseOrders", this.id);
  },
};
</script>
